import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import localeData from "dayjs/plugin/localeData";
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonItem,
  IonList,
  IonListHeader,
  IonRow,
} from "@ionic/react";

import {
  borrarObjetosDuplicados,
  ordenarArrayObjetosByDate,
} from "../../utils/funcionalidadesArrays";
import { convertToPlain } from "../../utils/funcionalidadesStrings";
import {
  mensajeMutualSinTurnosWeb,
  mutualPermiteTurnosWeb,
} from "../../utils/mutuales";
import CustomDesplegable from "../../components/basicsComponents/CustomDesplegable/CustomDesplegable";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast.jsx";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import CustomCalendar from "../../components/basicsComponents/Calendar";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";

dayjs.locale("es");
dayjs.extend(localeData);

export default function NuevoTurnoImagenes() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxio, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [estudios, setEstudios] = useState([]);
  const [estudioSeleccionado, setEstudioSeleccionado] = useState([{ codigo: -1 }]);
  const [fechasFuturas, setFechasFuturas] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [turnosPaciente, setTurnosPaciente] = useState([]);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [mostrarInasisEspecilidad, setMostrarInasisEspecilidad] = useState(false);
  const [mostrarTurnoPrestadorReservado, setMostrarTurnoPrestadorReservado] = useState(false);
  const [abrirDesplegableEstudios, setAbrirDesplegableEstudios] = useState(false);

  const [abrirModalConfirmarReserva, setAbrirModalConfirmarReserva] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const [mutualBloqueadaWeb, setMutualBloqueadaWeb] = useState(false);
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar las especialidades registradas en el sistema",
        "rojo"
      );
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnos = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios.get(`${url}Servicios`, config).then((response) => {
        if (response.data.length !== 0) {
          return response.data;
        } else {
          return null;
        }
      });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config
        );
        if (response.data.length !== 0) {
          turnos = response.data;
          turnos = turnos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnos = turnos.slice(0, 5);
        } else {
          turnos = [];
        }

        setTurnosPaciente(turnos);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo"
      );
    }
  };

  const traerHorariosEquipos = async (paciente) => {
    let horariosEquipos = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${urlAxio}EquiposHorarios`, config);
      if (response.data.length !== 0) {
        horariosEquipos = response.data;
        horariosEquipos = horariosEquipos.slice(0, 5);
      }

      setTurnosPaciente(horariosEquipos);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo"
      );
    }
  };

  const CargarDesplegables = async (sesion) => {
    // let prestadoresDisponibles = await traerPrestadores(sesion);
    await traerEstudios(sesion);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWebPortal");

        if (!mutualPermiteTurnosWeb(sesion)) {
          setMutualBloqueadaWeb(true);
          setCargando(false);
          return;
        }

        traerTurnosPaciente(sesion);
        CargarDesplegables(sesion);
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const traerTurnosAgenda = async (equipo) => {
    let agenda = [];
    let fechasTurnos = [];

    const agendaFiltradaPorRestriccion = [];
    let turnosProximos = [];
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };
    if (equipo && equipo !== 0) {
      try {
        let response = await axios.get(
          `${urlAxio}Turnos/TurnosEquipo?mutual=${usuario.mutual}&estudio=${equipo}`,
          config
        );

        if (response.data.length !== 0) {
          agenda = response.data;
        }
        agenda = agenda.filter((turno) => turno.libre && !turno.cancelado && turno.turnosWeb);
        agenda = agenda.filter(
          (turno) => dayjs(turno.fecha).isSame(dayjs()) || dayjs(turno.fecha).isAfter(dayjs())
        );

        agenda = agenda.filter(
          (turno) =>
            dayjs().format("YYYY-MM-DD") !== dayjs(turno.fecha).format("YYYY-MM-DD") ||
            (dayjs().format("YYYY-MM-DD") === dayjs(turno.fecha).format("YYYY-MM-DD") &&
              dayjs(turno.hora).format("HH:mm") > dayjs().add(2, "hour").format("HH:mm"))
        );

        if (agenda.length > 0) {
          agenda.forEach((turno) => {
            agendaFiltradaPorRestriccion.push(turno);
          });
        }

        borrarObjetosDuplicados(agendaFiltradaPorRestriccion, "fecha", true).forEach((turno) => {
          if (turno) {
            fechasTurnos.push({ fecha: turno, esFeriado: false });
          }
        });

        if (fechasTurnos.length > 0) {
          fechasTurnos.forEach((fecha) => {
            const fechaTurno = dayjs(fecha.fecha).format("YYYY-MM-DD");
            turnosProximos.push({
              date: fechaTurno,
              cantTurnos: agendaFiltradaPorRestriccion.filter((turno) =>
                dayjs(turno.fecha).isSame(fecha.fecha)
              ).length,
              textColor: "#800080",
              backgroundColor: "#ffc0cb",
            });
          });
        }

        setFechasFuturas(ordenarArrayObjetosByDate(turnosProximos, "date"));
        setFechaSeleccionada(ordenarArrayObjetosByDate(turnosProximos, "date")[0].date);
        setTurnosDisponibles(ordenarArrayObjetosByDate(agendaFiltradaPorRestriccion, "hora"));
      } catch (e) {
        mostrarNotificacion(
          true,
          //@ts-ignore
          "Error: " + e.response,
          "rojo"
        );
      }
    }
  };

  const traerHorariosAtencion = async (equipo) => {
    let horarios = null;
    let atiende = [];

    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    try {
      const [atiendeResponse] = await Promise.all([
        axios.get(`${urlAxio}Equipos/RestriccionesPorMutual/${equipo}`, config),
      ]);

      atiende = atiendeResponse.data.filter((a) => a.mutual === usuario.mutual);

      if (!atiende || !atiende[0]?.equipo) {
        mostrarNotificacion(true, "El prestador seleccionado no tiene un horario definido", "rojo");
      } else {
        await traerTurnosAgenda(config, equipo, horarios[0], atiende);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al intentar consultar los horarios disponibles del prestador",
        "rojo"
      );
    }
  };

  const actualizarTurno = async () => {
    if (!mutualPermiteTurnosWeb(usuario)) {
      mostrarNotificacion(true, mensajeMutualSinTurnosWeb, "amarillo");
      return;
    }

    try {
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      if (turnoSeleccionado) {
        const actualizarTurnoResponse = await axios.patch(
          `${urlAxio}Turnos/DarTurno/${turnoSeleccionado.codigo}`,
          {
            codigo: turnoSeleccionado.codigo,
            paciente: usuario.codigo,
            mutual: usuario.mutual,
            prestador: 0,
            estudio: estudioSeleccionado[0].codigo,
            equipo: turnoSeleccionado.equipo,
            telemedicina: turnoSeleccionado.telemedicina,
            observaciones: "Turno reservado via web por el paciente",
          },
          config
        );

        if (actualizarTurnoResponse.status === 200 && actualizarTurnoResponse.statusText === "OK") {
          mostrarNotificacion(true, "El turno se reservó correctamente", "verde");
          history.push({ pathname: "/portal/Turnos" });
        } else {
          mostrarNotificacion(true, "Ocurrió un problema al intentar reservar el turno", "rojo");
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const VerificarInasistenciasPorEspecialidad = (especialidad) => {
    const turnosPasados = turnosPaciente;
    let inasistidos = 0;

    turnosPasados.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") >= dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isAfter(new dayjs().subtract(2, "month")) &&
          dayjs(turno.fecha).isBefore(new dayjs()))
      ) {
        if (turno.especialidad === especialidad && turno.asistio === false) {
          inasistidos += 1;
        }
      }
    });

    setMostrarTurnoPrestadorReservado(false);
    if (inasistidos > 1) {
      setFechasFuturas([]);
      setMostrarInasisEspecilidad(true);
    } else {
      setMostrarInasisEspecilidad(false);
    }
  };

  const VerificarTurno = (estudio) => {
    const turnosFuturos = turnosPaciente;
    let turnoPendiente = false;
    turnosFuturos.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") <= dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isBefore(new dayjs().add(2, "month")) &&
          dayjs(turno.fecha).isAfter(new dayjs()))
      ) {
        if (turno.prestadorCod === estudio) {
          turnoPendiente = true;
        }
      }
    });

    if (turnoPendiente) {
      setFechasFuturas([]);
      setMostrarTurnoPrestadorReservado(true);
    } else {
      setMostrarTurnoPrestadorReservado(false);
      traerTurnosAgenda(estudio);
    }
  };

  const handleChangeSelect = (value, select) => {
    setCargando(true);
    let estudioSel = estudios.filter((estudio) => estudio.codigo === value);
    switch (select) {
      case "Estudio":
        setEstudioSeleccionado(estudioSel);
        setFechasFuturas([]);
        VerificarInasistenciasPorEspecialidad(value);
        VerificarTurno(value);
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
    setCargando(false);
  };

  const handleChangeFecha = (value) => {
    setFechaSeleccionada(value);
  };

  const togleAbrirCerrarConfirmarReserva = () => {
    if (abrirModalConfirmarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalConfirmarReserva(!abrirModalConfirmarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    if (!mutualPermiteTurnosWeb(usuario)) {
      mostrarNotificacion(true, mensajeMutualSinTurnosWeb, "amarillo");
      return;
    }

    setTurnoSeleccionado(turno);
    togleAbrirCerrarConfirmarReserva();
  };

  const handleClickConfirmarHacerReserva = async () => {
    setCargando(true);
    await actualizarTurno();
    togleAbrirCerrarConfirmarReserva();
    setFechaSeleccionada("");
    setTurnosDisponibles([]);
    await traerTurnosPaciente(usuario);
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "08105552765";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(true, "Se ha copiado el numero de telefono a su portapapeles", "");
  };

  const renderTurnos = () => {
    let turnos = turnosDisponibles.filter(
      (turno) =>
        dayjs(turno.fecha).format("YYYY-MM-DD") === dayjs(fechaSeleccionada).format("YYYY-MM-DD")
    );

    return turnos.map((turno) => (
      <IonCol sizeXs="12" sizeMd="6" sizeLg="3" key={turno.codigo}>
        <StyledButton
          expand="block"
          className="blanco"
          onClick={() => handleClickSeleccionarTurno(turno)}
        >
          {dayjs(turno.hora).format("HH:mm")}
        </StyledButton>
      </IonCol>
    ));
  };

  return (
    <>
      <div slot="content">
        {mutualBloqueadaWeb ? (
          <IonGrid>
            <IonRow className="ion-justify-content-center">
              <IonCol size="12" sizeMd="8">
                <IonCard color="warning">
                  <IonCardContent>
                    <h4 className="main-content">{mensajeMutualSinTurnosWeb}</h4>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        ) : (
          <>
            <IonGrid>
          <IonRow>
            <IonCol size="12">
              <IonItem className="amarillo-sol">
                <CustomDesplegable
                  array={estudios}
                  value={estudioSeleccionado[0].codigo}
                  handleChange={handleChangeSelect}
                  mostrarTodos={true}
                  mostrarSearch={true}
                  label={"Seleccione un estudio"}
                  id="Estudio"
                  isOpen={abrirDesplegableEstudios}
                  setIsOpen={setAbrirDesplegableEstudios}
                />
              </IonItem>
            </IonCol>
          </IonRow>
            </IonGrid>

            {fechasFuturas.length > 0 && (
              <IonGrid>
            {estudioSeleccionado[0].preparacion !== "" && (
              <IonRow className="ion-justify-content-center">
                <IonCol>
                  <IonCard color="warning">
                    <IonCardContent style={{ textAlign: "start" }}>
                      <h2 className="main-content">
                        PREPARACION: {convertToPlain(estudioSeleccionado[0].preparacion)}
                      </h2>
                    </IonCardContent>
                  </IonCard>
                </IonCol>
              </IonRow>
            )}
            <IonRow>
              <IonCol>
                <CustomCalendar
                  onChange={(newSelectedDate) =>
                    handleChangeFecha(dayjs(newSelectedDate).format("YYYY-MM-DD"))
                  }
                  minDate={dayjs(new dayjs())}
                  maxDate={dayjs(new dayjs()).add(2, "months")}
                  value={fechaSeleccionada}
                  highlightedDates={fechasFuturas}
                />
              </IonCol>
              {turnosDisponibles.length > 0 && (
                <IonCol>
                  <IonList lines="none">
                    <IonListHeader>
                      <h5>
                        Horarios disponibles para: {dayjs(fechaSeleccionada).format("DD/MM/YYYY")}
                      </h5>
                    </IonListHeader>

                    <IonGrid>
                      <IonRow>{renderTurnos()}</IonRow>
                    </IonGrid>
                  </IonList>
                </IonCol>
              )}
            </IonRow>
              </IonGrid>
            )}
          </>
        )}
      </div>

      {mostrarTurnoPrestadorReservado && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No esta permitido sacar un segundo turno para un mismo prestador
                </h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      )}

      <DialogoConfirmacion
        titulo="Reservar turno"
        texto={`Ha seleccionado el turno para el estudio ${
          estudioSeleccionado[0].nombre
        }, para el día ${dayjs(turnoSeleccionado.fecha).format("DD/MM/YYYY")}, a las ${dayjs(
          turnoSeleccionado.hora
        ).format("HH:mm")}, ¿es esto correcto?`}
        open={abrirModalConfirmarReserva}
        setOpen={setAbrirDesplegableEstudios}
        handleClickCancelar={togleAbrirCerrarConfirmarReserva}
        handleClickConfirmar={handleClickConfirmarHacerReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No, Revisar"
        textoBotonSi="Si, Confirmar"
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
